import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from  '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {tap,map} from 'rxjs/operators';
import {Subjects} from '../interface/subject';

@Injectable({
  providedIn: 'root'
})

export class SubjectService {

  httpOptions:any;
  headers:any;
  private _refreshNeeded$ = new Subject<void>();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  constructor(private http:HttpClient) 
    {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          'Authorization': 'my-auth-token'
        })
      };
    }
 
  postSubject(url,param){
      return this.http.post<Subjects>(url,param,this.httpOptions)
      .pipe(
        tap(() =>  {
          this._refreshNeeded$.next();
        })
      );
   }

// GetFilterModule(url){
//   return this.http.get(url,this.httpOptions).pipe(
//     map(items => {
//       return items.filter(items => items === 2);
//     }, error => error)
//   );
// }

getAllSubject(url){
    return this.http.get(url,this.httpOptions)
 }

GetSubjectByProgramIDModuleID(url,param){
  return this.http.get(url,this.httpOptions)
 }

getSubjectByID(url,param){
  return this.http.post<Subjects>(url,param,this.httpOptions)
}

getSubjectbyProgramID(url,param){
  return this.http.post<Subjects>(url,param,this.httpOptions)
}


updateSubject(url,param){
  return this.http.put<Subjects>(url,param,this.httpOptions)
  .pipe(
    tap(() =>  {
      this._refreshNeeded$.next();
    })
  );
}

deleteSubjectByID(url,param){
  return this.http.put<Subjects>(url,param,this.httpOptions)
  .pipe(
    tap(() =>  {
      this._refreshNeeded$.next();
    })
  );
}
}

